import { User, UserCreate } from '../../../types/user';
import { ApiAbstract } from '../abstract';

export class Apiuser extends ApiAbstract<UserCreate, User> {}
